import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { App } from './App';
import { MemoryRouter } from 'react-router';

let container = document.getElementById("app")!;
let root = createRoot(container)
root.render(
  <MemoryRouter>
    <App />
  </MemoryRouter>
);